export default {"src":"/_next/static/media/logo.b733e72a.svg","height":147,"width":131,"blurWidth":0,"blurHeight":0};